import { RfqSessionNudgeSettingChannelType } from './rfq-session-nudge-setting-channel-type';
import { RfqSessionNudgeSettingTriggerTimingAmountType } from './rfq-session-nudge-setting-trigger-amount-type';
import { RfqSessionNudgeSettingTriggerTimingTargetDirectionType } from './rfq-session-nudge-setting-trigger-timing-target-direction-type';
import { RfqSessionNudgeSettingTriggerTimingTargetType } from './rfq-session-nudge-setting-trigger-timing-target-type';
import { RfqSessionNudgeSettingType } from './rfq-session-nudge-setting-type';
import { ServiceType } from './service-type';
import { UserNotificationCategory } from './user-notification-category';

export class RfqSessionNudgeSetting {
	public id: number;
	public serviceTypeId: string;
	public rfqSessionNudgeSettingTypeId: number;
	public emailSender: string;
	public usageThreshold: number;
	public emailMessage: string;
	public smsMessage: string;
	public triggerTimingAmount: number;
	public rfqSessionNudgeSettingTriggerTimingAmountTypeId: number;
	public rfqSessionNudgeSettingTriggerTimingTargetTypeId: number;
	public rfqSessionNudgeSettingTriggerTimingTargetDirectionTypeId: number;
	public eventBasedDescription: string;
	public isActive: boolean;

	public serviceType: ServiceType;
	public rfqSessionNudgeSettingType: RfqSessionNudgeSettingType;
	public rfqSessionNudgeSettingChannelTypes: RfqSessionNudgeSettingChannelType[];
	public rfqSessionNudgeSettingTriggerTimingAmountType: RfqSessionNudgeSettingTriggerTimingAmountType;
	public rfqSessionNudgeSettingTriggerTimingTargetType: RfqSessionNudgeSettingTriggerTimingTargetType;
	public rfqSessionNudgeSettingTriggerTimingTargetDirectionType: RfqSessionNudgeSettingTriggerTimingTargetDirectionType;
	public userNotificationCategories: UserNotificationCategory[];

	constructor(rfqSessionNudgeSetting?: RfqSessionNudgeSetting) {
		Object.assign(this, rfqSessionNudgeSetting);
	}
}
